<template>
  <NuxtLayout>
    <div class="forgottenPassword container">
      <template v-if="!formSubmitted">
        <h1 v-text="$t('forgottenPassword.title')" />
        <p v-text="$t('forgottenPassword.description')" />
        <form @submit.prevent="submitForm" class="absoluteLabelsForm forgottenPassword__Form">
          <TextField v-model="form.email" :label="$t('forms.email')" type="email" :errors="formErrors?.field_errors?.email" />
          <Button class="forgottenPassword__FormButton" medium full-width :disabled="dataFetchInProgress">{{ $t('forgottenPassword.submit') }}</Button>
        </form>
      </template>
      <template v-else>
        <div class="forgottenPassword__Message">
          <Icon name="check-circle-fill"/>
          <p>{{ $t('forgottenPassword.checkEmail') }}</p>
          <Button type="nuxt-link" :to="link('Loyalty')" class="forgottenPassword__FormButton" medium full-width>{{ $t('close') }}</Button>
        </div>
      </template>
    </div>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });

  const props = defineProps({
    page: {
      type: Object
    }
  })

  const { link } = useSetup();

  const dataFetchInProgress = ref(false);
  const formSubmitted = ref(false);
  const formErrors = ref(null);
  const { customError, setCustomError } = useCustomFormErrors(formErrors.value);
  const form = ref({
    email: '',
  });

  async function submitForm() {
    dataFetchInProgress.value = true;
    try {
      let body = JSON.parse(JSON.stringify(form.value));
      for (let [key, value] of Object.entries(body)) {
        if (value === '') {
          body[key] = null;
        }
      }
      await useAuthFetch(`loyalty/reset/`, {
        method: 'POST',
        strategy: 'aminess',
        body: body,
        headers: {
          'Application-Origin': 'SHAPE-WEB'
        }
      });
      formSubmitted.value = true;
    } catch(error) {
      console.log(error)
      if (error.data) formErrors.value = error.data;

      if (error.response?._data?.errors && error.response?._data?.errors['profile.not_found']) {
        formErrors.value.field_errors = {
          email: 'no_active_account',
        };
      }

      setCustomError(formErrors.value);
    }
    dataFetchInProgress.value = false;
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_forgottenPassword.scss');
</style>